import { render, staticRenderFns } from "./AgregarAnulado.vue?vue&type=template&id=354acb6d&"
import script from "./AgregarAnulado.vue?vue&type=script&lang=js&"
export * from "./AgregarAnulado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports